<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute">
      <modal-cadu v-model="valueData" :width="1131.52" close>
        <div slot="all" class="pt-10 pb-4 px-10">
          <component-loading :value="loading" />

          <div slot="header">
            <div class="font-primaria primary1--text headline font-weight-bold">
              {{ acao === 'view' ? 'VISUALIZAR' : acao === 'edit' ? 'EDITAR' : 'ADICIONAR' }} MANDATO
            </div>
          </div>

          <div slot="body" v-if="!loading" class="border-body pb-6">
            <v-row align="center" class="pb-3">
              <v-col cols="12" sm="5" class="pb-0">
                <ValidationProvider
                  mode="eager"
                  ref="dominioMandato"
                  rules="required|alpha_spaces_dot"
                  v-slot:default="{ errors }"
                >
                  <autocomplete-cadu
                    :errorMessage="errors[0]"
                    v-model="tipoMandato"
                    :items="dominioMandatos.map((el) => el.nome)"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    :disabled="isView || isEdit || rowSize > 0"
                    title="Tipo de Mandato"
                    @index="(index) => indexIdMandato(index)"
                  />

                  <a
                    v-if="acao === 'add'"
                    @click="mandatoAnterior"
                    style="position: absolute; color: rgb(20, 146, 230)"
                    class="pb-4"
                  >
                    Importar dirigentes do mandato anterior
                  </a>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" sm="3" md="2" class="pb-0">
                <datepicker-cadu
                  width="280"
                  validateProviderRules="dateValidator|required"
                  inputTitle="Data Início"
                  typeCalendar="date"
                  :inputValue="dataInicio"
                  :disabled="isView"
                  @value="(value) => (dataInicio = value)"
                ></datepicker-cadu>
              </v-col>

              <v-col cols="12" sm="3" md="2" class="pb-0">
                <datepicker-cadu
                  width="280"
                  :validateProviderRules="regrasDataFinal"
                  inputTitle="Data Fim"
                  typeCalendar="date"
                  :minDate="dataInicio"
                  :inputValue="dataFim"
                  :disabled="isView"
                  @value="(value) => (dataFim = value)"
                />
              </v-col>

              <v-col cols="12" sm="3" md="auto" class="pt-10" v-if="acao === 'view'">
                <checkbox-cadu v-model="vigencia" disable>
                  <div slot="text">Vigente</div>
                </checkbox-cadu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-6 pt-4">
                <TableDirigentes
                  ref="tabelaDirigente"
                  :acao="acao"
                  :idMandato="objMandato.id"
                  :tipoDirigente="tipoDirigenteComputed"
                  :texto="isEdit && !isView ? '+ adicionar novo dirigente' : ''"
                  :visualizar="validaVisualizacao()"
                  @changeMandato="(id) => (objMandato.id = id)"
                  @click="gerenciaModalDirigentes"
                  @rowSize="(value) => (rowSize = value)"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="10" md="9" :class="$vuetify.breakpoint.xs ? '' : 'pb-0 pl-2 pr-1'">
                <ValidationProvider mode="eager" v-slot:default="{ errors }">
                  <textarea-cadu
                    :errorMessage="errors[0]"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    :disabled="isView || role !== 'admin_brasil'"
                    max="300"
                    title="Observações"
                    v-model="observacoes"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
          </div>

          <div slot="footer">
            <v-row justify="start" class="mt-4 pb-0" v-if="!$vuetify.breakpoint.xs">
              <v-col cols="auto" v-if="acao === 'edit'">
                <button-cadu text="CANCELAR" @click="verifyCancelar" :outline="true" />
              </v-col>
              <v-col cols="auto" v-if="acao === 'add'">
                <button-cadu text="VOLTAR" @click="valueData = false" outline />
              </v-col>
              <v-row justify="end" v-if="acao === 'view'">
                <v-col cols="auto">
                  <button-cadu text="VOLTAR" @click="valueData = false" outline />
                </v-col>
              </v-row>
              <v-row justify="end" v-if="acao === 'edit'">
                <v-col cols="auto">
                  <button-cadu text="LIMPAR" :backColor="$vuetify.theme.themes.light.primary2" @click="clean" />
                </v-col>
                <v-col cols="auto">
                  <button-cadu class="ma-4" text="SALVAR" @click="salvarMandato" />
                </v-col>
              </v-row>
              <v-row justify="end" v-if="acao === 'add'">
                <v-col cols="auto">
                  <button-cadu
                    text="SALVAR E ADICIONAR OUTRO"
                    block
                    class="px-4"
                    :backColor="$vuetify.theme.themes.light.primary2"
                    @click="newSalvarMandato"
                  />
                </v-col>
                <v-col cols="auto">
                  <button-cadu text="SALVAR" @click="salvarMandato" />
                </v-col>
              </v-row>
            </v-row>

            <v-row v-else>
              <v-row :class="$vuetify.breakpoint.xs ? '' : 'mr-2 mt-2'">
                <v-row v-if="acao === 'add'">
                  <v-col cols="12">
                    <button-cadu block>SALVAR</button-cadu>
                  </v-col>
                  <v-col cols="12">
                    <button-cadu
                      text="SALVAR E ADICIONAR OUTRO"
                      block
                      :backColor="$vuetify.theme.themes.light.primary2"
                      @click="newSalvarMandato"
                    />
                  </v-col>
                  <v-col cols="12">
                    <button-cadu block text="VOLTAR" @click="$emit('input', false)" outline />
                  </v-col>
                </v-row>
                <v-row v-if="acao === 'view'">
                  <v-col cols="12">
                    <button-cadu block text="VOLTAR" @click="$emit('input', false)" />
                  </v-col>
                </v-row>
                <v-row v-if="acao === 'edit'">
                  <v-col cols="12">
                    <button-cadu block text="LIMPAR" :backColor="$vuetify.theme.themes.light.primary2" @click="clean" />
                  </v-col>
                  <v-col cols="12">
                    <button-cadu block text="SALVAR" @click="salvarMandato" />
                  </v-col>
                  <v-col cols="12">
                    <button-cadu block text="CANCELAR" @click="verifyCancelar" :outline="true" />
                  </v-col>
                </v-row>
              </v-row>
            </v-row>
          </div>
        </div>
      </modal-cadu>
    </ValidationObserver>

    <ModalDirigentes
      ref="modalDirigentes"
      :idCargo="idMandato"
      :value="showDirigentes"
      @novamente="novamente"
      @input="fecharModalDirigente"
      :tipoMandato="tipoMandato"
      :nomeAcao="nomeAcaoDirigente"
      :dataInicio="dataInicio"
      :dataFim="dataFim"
      :vigencia="vigencia"
    />

    <error-modal :value="error" @input="fecharModal" :errObj="errObj" />

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />

    <overlay-loading :value="loadingOverlay" />

    <SucessoModal
      :showSucess="showSucess"
      :sucessType="nomeAcaoDirigente"
      successName="Dirigente"
      @close="closeSucesso"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mask } from 'vue-the-mask'
import TableDirigentes from './Shared/TableDirigentes'
import Mandatos from '@/services/Mandatos/Mandatos'
import jwtDecode from 'jwt-decode'
import { isEqual } from 'lodash'
import ModalDirigentes from '../Dirigentes/ModalDirigentes'
import Dirigentes from '@/services/Mandatos/Dirigentes'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  directives: {
    mask
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    TableDirigentes,
    ModalDirigentes
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    objMandato: {
      type: Object,
      required: false
    },
    acao: {
      type: String,
      required: false
    },
    isView: {
      type: Boolean,
      required: false
    },
    isEdit: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      tipoMandato: '',
      dataInicio: '',
      dataFim: '',
      observacoes: null,
      check: false,
      valueData: this.value,
      loading: false,
      role: '',
      dominioMandatos: [],
      tokenBearer: '',
      idMandato: null,
      loadingOverlay: false,
      showDirigentes: false,
      objDirigente: {},
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      cloneMandatos: {},
      showModalCancelar: false,
      checkAll: false,
      nomeAcaoDirigente: 'VISUALIZAR',
      showSucess: false,
      mandatos: '',
      rowSize: 0,
      cdUnimed: null
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.role = jwtDecode(this.tokenBearer).role
    this.mandatos = new Mandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
    this.cdUnimed = jwtDecode(this.tokenBearer).cdUnimed
  },
  computed: {
    canEdit() {
      return this.isEdit || this.role === 'admin_brasil' || this.role === 'dirigente'
    },
    regrasDataFinal() {
      if (this.dataInicio) {
        return `dateValidator|required|validateDataMandato: ${this.dataInicio} `
      } else {
        return 'dateValidator|required'
      }
    },
    // eslint-disable-next-line
    vigencia() {
      if (this.dataInicio && this.dataFim) {
        var partsInicio = this.dataInicio.split('/')
        var dayInico = parseInt(partsInicio[0], 10)
        var monthInicio = parseInt(partsInicio[1], 10)
        var yearInicio = parseInt(partsInicio[2], 10)
        var partsFim = this.dataFim.split('/')
        var dayFim = parseInt(partsFim[0], 10)
        var monthFim = parseInt(partsFim[1], 10)
        var yearFim = parseInt(partsFim[2], 10)

        let dataInicio = new Date(yearInicio, monthInicio - 1, dayInico)
        let dataFim = new Date(yearFim, monthFim - 1, dayFim)
        let dateNow = new Date()

        if (dateNow >= dataInicio && dateNow <= dataFim) {
          return true
        } else {
          return false
        }
      }
    },
    tipoDirigenteComputed() {
      return this.tipoMandato === null ? null : this.tipoMandato.includes('CONSELHO') ? 'conselheiro' : 'dirigente'
    }
  },
  methods: {
    async mandatoAnterior() {
      const res = await this.$refs.dominioMandato.validate()

      if (!res.valid) return

      const mandato = new Mandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      this.loadingOverlay = true

      try {
        await mandato.ultimoMandato(this.idMandato)
        this.$refs.tabelaDirigente.changePage(1)
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      } finally {
        this.loadingOverlay = false
      }
    },
    async novamente() {
      this.showDirigentes = false
      await this.$nextTick()
      this.showDirigentes = true
      this.valueData = false
    },
    async fecharModal() {
      this.error = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    async fecharModalDirigente() {
      this.showDirigentes = false
      await this.$nextTick()
      this.valueData = true
    },
    async closeSucesso() {
      this.showSucess = false
      this.valueData = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
      this.$emit('input', false)
    },
    async cancelarEdicao() {
      this.showModalCancelar = false
      this.$emit('input', false)
      // await this.start();
      // await this.$nextTick()
      // document.documentElement.style.overflow = 'hidden'
      // this.loading = true
      // this.populateData()
      // await this.$refs.tabelaDirigente.changePage(1)
      // this.loading = false
    },
    verifyCancelar() {
      let dirigentesMudaram = JSON.parse(localStorage.getItem('dirigentesMudaram'))
      let newObj = {
        tipoMandato: this.tipoMandato,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        check: this.ckeck,
        observacoes: this.observacoes
      }

      if (!isEqual(this.cloneMandatos, newObj) || dirigentesMudaram) {
        this.showModalCancelar = true
      } else {
        this.showModalCancelar = false
        this.$emit('input', false)
      }
    },
    inputDirigente(input) {
      this.showDirigentes = input
    },
    async iniciarEdicaoAdd() {
      try {
        await this.mandatos.iniciarEdicaoAdd()
      } catch (err) {
        console.error(err)
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async iniciarEdicaoEdit() {
      try {
        await this.mandatos.iniciarEdicaoEdit(this.objMandato.id)
      } catch (err) {
        console.error(err)
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async start() {
      localStorage.setItem('dirigentesMudaram', false)
      this.dataInicio = ''
      this.dataFim = ''
      this.observacoes = ''
      await this.$nextTick()
      this.loading = true
      if (this.acao === 'add') {
        await this.iniciarEdicaoAdd()
      } else if (this.acao === 'edit') {
        await this.iniciarEdicaoEdit()
      }
      await this.getDominioMandatos()
      this.tipoMandato = null
      if (this.acao !== 'add') {
        await this.$nextTick()
        this.populateData()
      }
      this.loading = false
    },
    async gerenciaModalDirigentes(obj) {
      const val = await this.$refs.observer.validate()

      if (obj.type === 'add' && !val) return

      this.loadingOverlay = true

      await this.$refs.modalDirigentes.getCargos()

      switch (obj.type) {
        case 'add':
          this.nomeAcaoDirigente = 'ADICIONAR'
          this.valueData = false
          await this.$nextTick()
          this.showDirigentes = true
          this.loadingOverlay = false
          break

        case 'edit':
          this.nomeAcaoDirigente = 'EDITAR'
          await this.getDirigente(obj.dirigente.id)
          this.loadingOverlay = false
          break

        case 'view':
          this.nomeAcaoDirigente = 'VISUALIZAR'
          await this.getDirigente(obj.dirigente.id)
          this.loadingOverlay = false
          break
      }
    },
    async getDirigente(id) {
      const dirigente = new Dirigentes(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      try {
        const res =
          this.acao === 'view'
            ? await dirigente.getDirigenteEdit(id, this.objMandato.id)
            : await dirigente.getDirigenteAdd(id)
        this.objDirigente = res.data
        this.valueData = false
        await this.$nextTick()
        this.showDirigentes = true
        await this.$nextTick()
        await this.$refs.modalDirigentes.preencherTodosCampos(this.objDirigente)
        this.loadingOverlay = false
      } catch (err) {
        console.error(err)
        this.loadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async getDominioMandatos() {
      let mandatos = new Mandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseDominio = await mandatos.getTipoMandato()
        this.dominioMandatos = responseDominio.data
      } catch (err) {
        console.error(err)
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    indexIdMandato(index) {
      this.idMandato = index > -1 && index !== null ? this.dominioMandatos[index].id : ''
    },
    populateData() {
      this.dominioMandatos = [this.objMandato.tipoMandato]
      this.tipoMandato = this.objMandato.tipoMandato.nome
      this.dataInicio = this.objMandato.dataInicioVigencia
      this.dataFim = this.objMandato.dataFimVigencia
      this.check = this.objMandato.vigente
      this.observacoes = this.objMandato.observacao

      this.cloneMandatos = {
        tipoMandato: this.tipoMandato,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        check: this.ckeck,
        observacoes: this.observacoes
      }
    },
    clean() {
      this.dataInicio = ''
      this.dataFim = ''
      if (this.role === 'admin_brasil') {
        this.observacoes = ''
      }
    },
    async putMandatos(bool) {
      let mandatos = new Mandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      let obj = {
        dataFimVigencia: this.dataFim,
        dataInicioVigencia: this.dataInicio,
        id: this.isEdit ? this.objMandato.id : null,
        tipoMandato: {
          id: this.isEdit ? this.objMandato.tipoMandato.id : this.idMandato
        },
        observacao: this.observacoes
      }

      await mandatos
        .putMandatos(obj)
        .then((res) => {
          if (bool && res) {
            this.$emit('new-save')
          } else if (res) {
            this.valueData = false
            this.$emit('save')
          }
          EventBus.$emit('resolverAlertaNotificaoPendente', { tipoNotificacao: 'MANDATO_VENCIDO' })
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async salvarMandato() {
      if (this.rowSize <= 0) {
        this.error = true
        this.errObj.status = ''
        this.errObj.error = 'Não é possivel salvar um mandato sem dirigente.'
        return
      }
      this.loadingOverlay = true
      if (await this.$refs.observer.validate()) {
        try {
          await this.putMandatos(false)
        } catch (err) {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          console.error(err)
        }
      }
      this.loadingOverlay = false
    },
    async newSalvarMandato() {
      if (this.rowSize <= 0) {
        this.error = true
        this.errObj.status = ''
        this.errObj.error = 'Não é possivel salvar um mandato sem dirigente.'
        return
      }
      this.loadingOverlay = true
      if (await this.$refs.observer.validate()) {
        try {
          await this.putMandatos(true)
        } catch (err) {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          console.error(err)
        }
      }
      this.loadingOverlay = false
    },
    validaVisualizacao() {
      if (this.role == 'admin_brasil' || (this.role == 'dirigente' && this.cdUnimed == this.$idUnimed)) {
        return [true, true, true]
      }

      return [false, false, false]
    }
  },
  watch: {
    value() {
      this.valueData = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.border-body
  border-bottom: 1px solid #9E9E9E80
</style>
